import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoginContainer, LoginForm, Input, Button, Error, LoginHeader, Logo } from './Login.styles';
import logo from '../assets/logo.png';

const Login: React.FC = () => {
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validationSchema: Yup.object({
            username: Yup.string().required('Required'),
            password: Yup.string().required('Required'),
        }),
        onSubmit: async (values) => {
            try {
                const response = await api.post(`/api/auth/login`, values);
                localStorage.setItem('token', response.data.token);
                navigate('/');
            } catch (error) {
                toast.error('Invalid username or password');
            }
        },
    });

    return (
        <LoginContainer>
            <LoginForm onSubmit={formik.handleSubmit}>
                <LoginHeader>
                    <Logo src={logo} alt="Logo" />
                    <h1>Login</h1>
                </LoginHeader>
                <Input
                    id="username"
                    name="username"
                    type="text"
                    placeholder="Username"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.username}
                />
                {formik.touched.username && formik.errors.username ? (
                    <Error>{formik.errors.username}</Error>
                ) : null}
                <Input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                />
                {formik.touched.password && formik.errors.password ? (
                    <Error>{formik.errors.password}</Error>
                ) : null}
                <Button type="submit">Login</Button>
            </LoginForm>
        </LoginContainer>
    );
};

export default Login;
